<template>
  <li class="TimelineItem mb2">
    <time class="TimelineItem-date mb0-25">
      <slot name="date"></slot>
    </time>
    <div class="TimelineItem-content">
      <slot name="content"></slot>
    </div>
  </li>
</template>

<script lang="ts" setup>

</script>

<style lang="scss">
.TimelineItem {
  position: relative;
  padding-inline-start: 1rem;

  &::before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    left: -5px;
    top: 0.4em;
    background-color: $blackBorder;
    border-radius: 50%;
  }

  &-date {
    display: block;
    font-weight: 300;
  }

  &-content {
  }
}
</style>
